import { Component, Inject } from "@angular/core";

@Component({
    selector: "instructions-dialog",
    templateUrl: "instructions-dialog.html",
    standalone: false
})
  export class InstructionsDialog {
    constructor() {}
  }